export default {"src":"/_next/static/media/pc_consultunt_img_03.c75ae005.svg","height":140,"width":480};